import { render } from "./attFot.vue?vue&type=template&id=111b032c&scoped=true"
import script from "./attFot.vue?vue&type=script&lang=js"
export * from "./attFot.vue?vue&type=script&lang=js"

import "./attFot.vue?vue&type=style&index=0&id=111b032c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111b032c"]])

export default __exports__